/* Vanshitaaz wishlist — localStorage-backed, no account required.
   Heart buttons live in the collection-2026 card strip ([data-c26-wish]).
   This file owns storage + the heart toggle + the header bubble; the
   drawer itself (rendering saved cards, totals) is wishlist-drawer.js. */
(function () {
  'use strict';

  var STORAGE_KEY = 'vz_wishlist';
  var EVENT = 'vz:wishlist:change';

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) { return []; }
  }

  function write(items) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { /* storage unavailable */ }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { count: items.length, items: items } }));
  }

  function has(id) {
    id = String(id);
    return read().some(function (item) { return String(item.id) === id; });
  }

  function add(data) {
    var items = read();
    if (items.some(function (item) { return String(item.id) === String(data.id); })) return items;
    items.push(data);
    write(items);
    return items;
  }

  function remove(id) {
    id = String(id);
    var items = read().filter(function (item) { return String(item.id) !== id; });
    write(items);
    return items;
  }

  // toggles from a [data-c26-wish] button, reading its card's data-* attrs
  function toggleFromButton(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    if (has(id)) {
      remove(id);
      return false;
    }
    // collection cards carry their data on a [data-c26-card] ancestor; a
    // standalone heart (e.g. the PDP one next to Add to Cart, which has no
    // such ancestor) carries the same data-* attributes on itself instead.
    var source = btn.closest('[data-c26-card]') || btn;
    add({
      id: id,
      handle: source.getAttribute('data-handle') || '',
      title: source.getAttribute('data-title') || '',
      url: source.getAttribute('data-url') || '',
      img: source.getAttribute('data-img') || '',
      fabric: source.getAttribute('data-fabric') || '',
      priceCents: parseInt(source.getAttribute('data-price-cents'), 10) || 0,
      compareCents: parseInt(source.getAttribute('data-compare-cents'), 10) || 0
    });
    return true;
  }

  function syncHeart(btn) {
    var id = btn.getAttribute('data-product-id');
    var active = has(id);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function syncAllHearts() {
    document.querySelectorAll('[data-c26-wish]').forEach(syncHeart);
  }

  // The header heart is a static drawer-opening icon (like the cart icon,
  // which never recolors when the cart has items) — only its count bubble
  // changes. The red "saved" fill belongs to the card heart, not this one.
  function syncBubble() {
    var bubble = document.getElementById('wishlist-count-bubble');
    var count = read().length;
    if (bubble) {
      var numEl = bubble.querySelector('[aria-hidden]');
      if (numEl) numEl.textContent = count > 99 ? '99+' : String(count);
      bubble.classList.toggle('is-visible', count > 0);
    }
  }

  document.addEventListener('click', function (evt) {
    var heartBtn = evt.target.closest('[data-c26-wish]');
    if (heartBtn) {
      evt.preventDefault();
      toggleFromButton(heartBtn);
      syncHeart(heartBtn);
      return;
    }
  });

  window.addEventListener(EVENT, syncBubble);

  document.addEventListener('DOMContentLoaded', function () {
    syncAllHearts();
    syncBubble();
  });
  if (document.readyState !== 'loading') { syncAllHearts(); syncBubble(); }

  // classic Shopify money formatter (amount is in cents)
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimalSep) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimalSep = decimalSep == null ? '.' : decimalSep;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decimalPart = parts[1] ? decimalSep + parts[1] : '';
      return dollars + decimalPart;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : value;
  }

  window.VZWishlist = {
    EVENT: EVENT,
    getAll: read,
    has: has,
    add: add,
    remove: remove,
    count: function () { return read().length; },
    formatMoney: formatMoney
  };
})();
